import { Chart } from "primereact/chart";
import React, { useEffect, useState } from "react";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "./estimatedDonationsChart.scss";

const WeeklyDonationsChart = (props) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (props.weeklyData && props.weeklyData.length > 0) {
      const labels = props.weeklyData.map((w) => w.weekLabel);
      const amounts = props.weeklyData.map((w) => w.totalAmount || 0);

      setChartData({
        labels: labels,
        datasets: [
          {
            label: "Donations",
            data: amounts,
            backgroundColor: "#0095FF",
            borderRadius: 4,
          },
        ],
      });
    }
  }, [props.weeklyData]);

  const options = {
    maintainAspectRatio: false,
    aspectRatio: 0.7,
    plugins: {
      datalabels: {
        color: "#f3f6f4",
        font: {
          size: "12px",
          weight: "600",
        },
        display: function (context) {
          return context.dataset.data[context.dataIndex] > 0;
        },
        formatter: function (value) {
          if (value >= 1000) return (value / 1000).toFixed(0) + "k";
          return value;
        },
      },
      legend: {
        display: true,
        position: "top",
        labels: {
          color: "#495057",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#495057",
        },
        grid: {
          color: "#ebedef",
          drawBorder: false,
        },
      },
      y: {
        title: {
          display: true,
          text: "Amount (Rs)",
          color: "#495057",
          font: { size: 11, weight: "bold" },
        },
        ticks: {
          color: "#495057",
        },
        grid: {
          color: "#ebedef",
          drawBorder: false,
        },
      },
    },
  };

  return (
    <div className="layout-main widther">
      <div className="card-1">
        <Chart
          type="bar"
          data={chartData}
          options={options}
          plugins={[ChartDataLabels]}
        />
      </div>
    </div>
  );
};

export default WeeklyDonationsChart;
